export enum BreadcrumbIcons {
  Right_Arrow = 'right-arrow',
  Down_Arrow = 'arrow-down',
  Ellipsis = 'ellipsis',
  Up_Arrow = 'up_arrow',
  Right_Arrow_Dashed = 'arrow-right-dash',
}

export enum BreadcrumbCollapsed {
  CollapseAfterThree = 3,
  CollapseAfterFour = 4,
  CollapseAfterFive = 5,
  CollapseAfterSix = 6,
}
